import React, { useState, useRef, useEffect, useContext } from "react";
import { NavLink, Link } from "react-router-dom";
import "./BeforeGiftCardScreen.scss";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'
import atar_logo from "../../assets/home/atar_logo.png";
import ammzion from "../../assets/home/ammzion.png";
import { useTranslation } from "react-i18next";
import { StarButton } from '../../components'
import { singleUser } from '../../store/UserRedux'

const BeforeContestGiftCard = () => {
  const history = useHistory();
  const dispatch = useDispatch()
  const [time, setTime] = useState(0);
  let counter;
  const { t, i18n } = useTranslation();
  const token = useSelector((state) => state.auth.token)
  const currentUser = useSelector((state) => state.auth.user)

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(singleUser({ id: currentUser._id, token }));
    calculateTime()
    return () => {
      clearInterval(counter);
    }
  }, [])

  const calculateTime = () => {
    var timeleft = 10;
    counter = setInterval(() => {
      if (timeleft <= 0) {
        history.push("/contestflow")
        clearInterval(counter);
      }
      setTime(timeleft)
      timeleft = timeleft - 1;
    }, 1000)
  }

  return (
    <>
      <div className="container-fluid">
        <div className="amazon_sec">
          <NavLink className={'mobiles'} to=""><img className="giftcar_logo" src={atar_logo} /></NavLink>
          <div className="befor_gift">
            <div className="befor_hed">
              <div className="text_area">
                <div className="text_area_sec">
                  <NavLink className={'destops'} to=""><img className="giftcar_logo" src={atar_logo} /></NavLink>
                  <div className="stars_logo">
                    <img className="ammzion" src={ammzion} />
                  </div>
                  <div className="gift ">
                    <h4>{t("beforecontest.titel1")}</h4>
                    <p>{t("beforecontest.para")}</p>
                    <div className="redirecting destops"> {t("beforecontest")} <span>{time} </span>{t("beforecontest1")} </div>
                    <div className="play destops">
                      <StarButton background={'mainBg'} title={t("beforecontest.btn")} onClickAction={() => history.push("/contestflow")} />
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div className="play mobiles">
              <div className="redirecting"> {t("beforecontest")} <span>{time} </span>{t("beforecontest1")} </div>
              <StarButton background={'mainBg'} title={t("beforecontest.btn")} onClickAction={() => history.push("/contestflow")} />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default BeforeContestGiftCard